// extracted by mini-css-extract-plugin
module.exports = {"email":"styles-module__email___npryh","categoryWrapper":"styles-module__categoryWrapper___1sNUG"};